import { useState, useEffect, Fragment } from 'react'
import './ShopMoreProduct.scss'

import {
    slugify,
    SIZES,
    fileNameAndExt,
    getUniqueListBy,
    getCookie,
} from '../../helpers/helpers'

const PRODUCTS_URL = 'https://monicaandandy.com/products/'

const PRODUCT_FILES_URL =
    'https://cdn.shopify.com/s/files/1/2338/2917/products/'

const FILES_URL = 'https://cdn.shopify.com/s/files/1/2338/2917/files/'

const DEFAULT_IMAGE_SRC =
    'https://cdn.shopify.com/s/files/1/2338/2917/files/default-image.png?v=1628278950'

const currentOriginUrl = window.location.origin

const Product = ({ product, queryTerm, queryType, mainProduct }) => {
    // console.log('queryType, queryTerm in product', queryType, queryTerm)
    let variants = product.variants
    let variant
    let v

    let imageSrc

    variants.map((i) => {
        // console.log('i', i)
        if (
            queryType.indexOf('print') > -1 &&
            i.title.indexOf(queryTerm) > -1
        ) {
            imageSrc = i.image
            variant = i
            v = variant
        } else if (
            queryType.indexOf('product') > -1 &&
            i.product_type.indexOf(queryTerm) > -1
        ) {
            imageSrc = i.image
            variant = i
            v = variant
        } else {
            variant = i
            v = variant
        }
        return null
    })

    const imageAlt = 'variant image'

    let smallImageSource = ''

    let imageSrcArray

    if (imageSrc && imageSrc.length) {
        imageSrcArray = fileNameAndExt(imageSrc)
        // console.log('imageSrc, imageSrcArray', imageSrc, imageSrcArray)
        smallImageSource =
            PRODUCT_FILES_URL +
            imageSrcArray[0] +
            '_400x400.' +
            imageSrcArray[1]
        // console.log('smallImageSource', smallImageSource)
    } else {
        imageSrc = variants[0].image
    }

    const [sizes, setSizes] = useState('')
    const [currentPattern, setCurrentPattern] = useState('')

    const [value, setValue] = useState('Size')
    // const [currentVariantId, setCurrentVariantId] = useState(v.id ? v.id : '')
    // const [currentVariantId, setCurrentVariantId] = useState()

    const patternList = variants
        .filter((p) => {
            return p.product_id === v.product_id
        })
        .map((v) => {
            return v.initial_color
        })

    const patterns = [...new Set(patternList)]

    // console.log('patterns', patterns)

    let matchingVariants = variants.filter((m) => {
        if (queryType.indexOf('print') > -1) {
            return m.initial_color.indexOf(queryTerm) > -1
        } else if (queryType.indexOf('product') > -1) {
            if (queryTerm) {
                return m.product_type.indexOf(queryTerm) > -1
            } else {
                return variants
            }
        }
        return null
    })

    if (!matchingVariants.length) {
        matchingVariants = variants
    }

    // console.log('matchingVariants, queryType', matchingVariants, queryType)

    let firstVariant = matchingVariants.find(function (el) {
        return el.inventory_quantity > 0
    })

    if (!firstVariant || firstVariant.length === 0) {
        firstVariant = matchingVariants[0]
    }

    // console.log('firstVariant', firstVariant)

    const [currentVariantId, setCurrentVariantId] = useState(
        firstVariant ? firstVariant.id : v.id
    )

    const [currentImage, setCurrentImage] = useState({
        src: firstVariant && firstVariant.image ? firstVariant.image : imageSrc,
        alt: imageAlt,
    })

    useEffect(() => {
        if (
            firstVariant &&
            queryType === 'print' &&
            currentVariantId !== firstVariant.id &&
            queryTerm === firstVariant.initial_color
        ) {
            setCurrentVariantId(firstVariant ? firstVariant.id : v.id)
            setCurrentImage({
                src:
                    firstVariant && firstVariant.image
                        ? firstVariant.image
                        : imageSrc,
                alt: imageAlt,
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [firstVariant])

    useEffect(() => {
        let sizeList = matchingVariants.map((m) => {
            return {
                id: m.id,
                size: m.initial_size,
                quantity: m.inventory_quantity,
            }
        })

        // console.log('sizeList', sizeList)

        let sortedSizeList = sizeList.sort(sortFunc)

        sortedSizeList = getUniqueListBy(sortedSizeList, 'size')

        // console.log('sortedSizeList', sortedSizeList)

        if (sortedSizeList) {
            setSizes(sortedSizeList)
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (
            queryType === 'print' &&
            variant.initial_color.indexOf(queryTerm) > -1
        ) {
            let initialPattern = variant.initial_color
            // console.log('initialPattern', variant.title, initialPattern)
            setCurrentPattern(initialPattern)
        } else if (queryType === 'product') {
            let initialPattern = firstVariant.initial_color
            setCurrentPattern(initialPattern)
        }
    }, [variant, queryTerm, queryType, firstVariant])

    // console.log('sortedSizeList', sortedSizeList)

    const handleSwatchClick = async (productId, pattern) => {
        // console.log('swatch clicked')
        setCurrentPattern(pattern)

        // update list of matches
        matchingVariants = variants.filter((m) => {
            return m.product_id === productId && m.initial_color === pattern
        })

        // console.log("matchingVariants after swatch click", matchingVariants);

        // extract sizes from new matches
        let sizeList = matchingVariants.map((m) => {
            return {
                id: m.id,
                size: m.initial_size,
                quantity: m.inventory_quantity,
            }
        })

        // console.log('sizeList', sizeList)

        let sortedSizeList = sizeList.sort(sortFunc)

        if (sortedSizeList) {
            setSizes(sortedSizeList)
        }

        const firstMatchWithInventory = matchingVariants.find(function (el) {
            return el.inventory_quantity > 0
        })

        // console.log('firstMatchWithInventory', firstMatchWithInventory)

        if (firstMatchWithInventory) {
            setCurrentImage({
                src: firstMatchWithInventory.image,
                alt: imageAlt,
            })
        }

        let btnEl

        if (value === 'Size' || value === 'undefined' || value === null) {
            // console.log('swatch selected one size', firstMatchWithInventory.id)
            if (firstMatchWithInventory) {
                let x = firstMatchWithInventory.id
                await setCurrentVariantId(firstMatchWithInventory.id)

                btnEl = document.querySelectorAll(
                    `.registry-trigger[data-variant-id="${firstMatchWithInventory.id}"]`
                )
            } else {
                await setCurrentVariantId(firstVariant.id)
                btnEl = document.querySelectorAll(
                    `.registry-trigger[data-variant-id="${firstVariant.id}"]`
                )
            }
        } else {
            // get variant ID for new pattern variant in selected size
            let selectedSizeVariant = matchingVariants.filter((m) => {
                return m.initial_size === value
            })
            // console.log(
            //     'selectedSizeVariant',
            //     selectedSizeVariant,
            //     selectedSizeVariant[0].id
            // )
            await setCurrentVariantId(selectedSizeVariant[0].id)
            btnEl = document.querySelectorAll(
                `.registry-trigger[data-variant-id="${selectedSizeVariant[0].id}"]`
            )
        }

        if (btnEl) {
            btnEl.forEach((i) => (i.innerHTML = 'Add to Registry'))
        }
    }

    const handleSizeSelect = (e) => {
        // console.log('e.target Size', e.target)
        let variantId =
            e.target[e.target.selectedIndex].getAttribute('data-variant-id')
        // console.log('variantId on size select', variantId)
        setValue(e.target.value)
        setCurrentVariantId(variantId)
    }

    function sortFunc(a, b) {
        let sortingArr = SIZES
        return sortingArr.indexOf(a.size) - sortingArr.indexOf(b.size)
    }

    const addProductToRegistry = async (
        itemUrl,
        title,
        imageUrl,
        currentVariantId,
        quantity,
        selectorId = undefined
    ) => {
        let itemDetail = {
            url: itemUrl,
            quantity: quantity,
            maRegistryImage: imageUrl,
            title: title,
        }

        let registries = getCookie('ma_registry_id')
        let token = getCookie('access_token')

        if (!(window.hasRegistry === 'True' || window.hasRegistry === true)) {
            window.openRegistryModal(itemDetail)
            return
        }

        if (registries && !window.registryId) {
            let allRegistries = JSON.parse(decodeURIComponent(registries))
            if (allRegistries.length > 0) {
                window.registryId = allRegistries[allRegistries.length - 1].id
            }
        }

        if ((token || token.length) && !window.registryId) {
            await window.verifyToken(itemDetail)
        }

        if (window.registryId) {
            const ADD_REGISTRY_ITEM = `
              mutation addRegistryItemsByVariant($itemUrl: String!, $imageUrl: String!, $registryId: Int!, $title: String!, $quantity: Int!)
              { addRegistryItemsByVariant(itemUrl: $itemUrl, imageUrl: $imageUrl, registryId: $registryId, title: $title, quantity: $quantity) {
                  message
                  }
              }
          `

            const add_product_headers = {
                'Content-Type': 'application/json',
                Authorization: 'Token ' + getCookie('access_token'),
            }

            let reqData = {
                query: ADD_REGISTRY_ITEM,
                variables: {
                    itemUrl: itemUrl,
                    imageUrl: imageUrl,
                    registryId: Number(window.registryId),
                    title: title,
                    quantity: quantity,
                },
            }

            let addProductToRegistry = fetch(window.graphqlEndpoint, {
                method: 'POST',
                headers: add_product_headers,
                body: JSON.stringify(reqData),
            })

            addProductToRegistry
                .then((res) => res.json())
                .then((data) => {
                    let btnEl = document.querySelectorAll(
                        `.registry-trigger[data-variant-id="${currentVariantId}"]`
                    )
                    if ((data.errors || data.error) && btnEl.length) {
                        btnEl.forEach(
                            (i) => (i.innerHTML = 'Try adding after sometime')
                        )
                    } else {
                        localStorage.removeItem('maRePrURL')
                        if (selectorId) {
                            let spanButton = document.querySelector(
                                '#' + selectorId
                            )
                            if (spanButton) {
                                spanButton.innerHTML = 'Item Added to Registry'
                                spanButton.style.width = '60%'
                                spanButton.style.color = '#2ea9be'
                                // spanButton.style.w
                            }
                        } else if (btnEl.length) {
                            btnEl.forEach((i) => {
                                i.style.width = '200px'
                                i.innerHTML = 'Item Added to Registry'
                            })
                        }
                    }
                })
                .catch((err) => {
                    console.log('Error while adding product: ', err)
                    let btnEl = document.querySelectorAll(
                        `.registry-trigger[data-variant-id="${currentVariantId}"]`
                    )
                    if (btnEl.length) {
                        btnEl.forEach(
                            (i) => (i.innerHTML = 'Try adding after sometime')
                        )
                    }
                })
        } else {
            window.openRegistryModal(itemDetail)
        }
    }

    const nullFunction = () => {}

    let productHandle

    if (product && product.handle) {
        productHandle = product.handle.split('_')[0]
        productHandle = productHandle.replace(/trunk-sale-/g, '')
        productHandle = productHandle.replace(/sale-/g, '')
        productHandle = productHandle.replace(/-1$/, '')
        productHandle = productHandle.replace(/-2$/, '')
        productHandle = productHandle.replace(/-3$/, '')
        productHandle = productHandle.replace(/-4$/, '')
        productHandle = productHandle.replace(/-5$/, '')
    }

    return (
        <Fragment>
            {firstVariant ? (
                <li
                    className="shop-more-product product"
                    key={firstVariant}
                    data-product-id={product.id}
                >
                    <div className="height">
                        <div className="product-outer">
                            <div
                                className="product-image"
                                data-color={firstVariant.initial_color}
                                data-variant-id={
                                    currentVariantId && currentVariantId
                                }
                            >
                                <a
                                    href={`${PRODUCTS_URL}${productHandle}${
                                        currentVariantId & currentVariantId
                                            ? '?variant=' + currentVariantId
                                            : ''
                                    }`}
                                >
                                    <img
                                        src={
                                            currentImage && currentImage.src
                                                ? currentImage.src
                                                : DEFAULT_IMAGE_SRC
                                        }
                                        alt={imageAlt ? imageAlt : null}
                                    />
                                </a>
                            </div>

                            <div className="product-inner">
                                <div className="product-top">
                                    <h3 className="product-title">
                                        {product.title.split('_')[0]}
                                    </h3>
                                    <p className="product-price">
                                        ${firstVariant.price}{' '}
                                        {firstVariant.compare_at_price &&
                                        firstVariant.compare_at_price !==
                                            null ? (
                                            <span className="compare-at-price">
                                                ${firstVariant.compare_at_price}
                                            </span>
                                        ) : null}
                                    </p>
                                    <p className="product-available">
                                        Available in {patterns.length}{' '}
                                        {patterns.length === 1
                                            ? 'color'
                                            : 'colors'}
                                    </p>
                                </div>
                                <div className="product-bottom">
                                    <div className="product-swatches">
                                        <p className="swatch-heading">
                                            Prints + Colors:
                                        </p>
                                        <ul className="swatch-list nostyle">
                                            {patterns
                                                ? patterns.map((p) => {
                                                      //   console.log(
                                                      //       'p in patterns map',
                                                      //       p
                                                      //   )
                                                      return (
                                                          <li
                                                              key={
                                                                  product.id +
                                                                  ' ' +
                                                                  p
                                                              }
                                                              className={`sm-swatch ${
                                                                  p ===
                                                                  currentPattern
                                                                      ? 'selected-swatch'
                                                                      : ''
                                                              }`}
                                                              onClick={() =>
                                                                  handleSwatchClick(
                                                                      product.id,
                                                                      p
                                                                  )
                                                              }
                                                          >
                                                              <div
                                                                  className="swatch-image"
                                                                  data-product-id={
                                                                      v.id
                                                                  }
                                                                  data-pattern={
                                                                      p
                                                                          ? slugify(
                                                                                p
                                                                            )
                                                                          : null
                                                                  }
                                                                  aria-label={p}
                                                                  data-balloon-pos="up"
                                                              >
                                                                  <img
                                                                      className="swatch-image"
                                                                      src={`${FILES_URL}maswatch-${
                                                                          p
                                                                              ? slugify(
                                                                                    p
                                                                                )
                                                                              : 'default'
                                                                      }-96.png`}
                                                                      alt={`${
                                                                          p
                                                                              ? p
                                                                              : 'default'
                                                                      } swatch`}
                                                                      data-pattern={
                                                                          p
                                                                      }
                                                                  />
                                                              </div>
                                                          </li>
                                                      )
                                                  })
                                                : null}
                                        </ul>
                                    </div>
                                    <div
                                        className={`product-actions ${
                                            sizes && sizes.length < 2
                                                ? 'no-sizes'
                                                : null
                                        }`}
                                    >
                                        <div className="product-sizes">
                                            <select
                                                className={`product-size-select select-css`}
                                                onChange={handleSizeSelect}
                                                value={value}
                                                data-value={value}
                                                data-variant-id={
                                                    currentVariantId
                                                }
                                            >
                                                <option
                                                    key="null-size-option"
                                                    className="default-option"
                                                    data-variant-id={null}
                                                >
                                                    Size
                                                </option>
                                                {sizes && sizes
                                                    ? sizes.map((s) => {
                                                          // console.log('s in size select', s)
                                                          if (s) {
                                                              return (
                                                                  <option
                                                                      key={`${s.id}-${s.size}-${s.quantity}`}
                                                                      data-variant-id={
                                                                          s.id
                                                                      }
                                                                      value={
                                                                          s.size
                                                                      }
                                                                      data-inventory={
                                                                          s.quantity
                                                                      }
                                                                      className={
                                                                          s.quantity >
                                                                          0
                                                                              ? 'available'
                                                                              : 'disabled'
                                                                      }
                                                                      disabled={
                                                                          s.quantity >
                                                                          0
                                                                              ? false
                                                                              : true
                                                                      }
                                                                  >
                                                                      {s.size}
                                                                  </option>
                                                              )
                                                          }
                                                          return false
                                                      })
                                                    : null}
                                            </select>
                                        </div>

                                        <div className="product-add-to-cart">
                                            <form
                                                action="/cart/add"
                                                acceptCharset="UTF-8"
                                                encType="multipart/form-data"
                                                className="product-atc"
                                            >
                                                <input
                                                    type="hidden"
                                                    min="1"
                                                    name="quantity"
                                                    value="1"
                                                />
                                                <input
                                                    type="hidden"
                                                    name="id"
                                                    value={
                                                        currentVariantId
                                                            ? currentVariantId
                                                            : ''
                                                    }
                                                />
                                                {sizes && sizes.length > 2 ? (
                                                    <button
                                                        type="submit"
                                                        className={`large-button button-atc ${
                                                            value &&
                                                            value === 'Size'
                                                                ? 'disabled'
                                                                : null
                                                        }`}
                                                        data-variant-id={
                                                            currentVariantId
                                                        }
                                                        data-balloon-blunt
                                                        data-balloon-pos="up"
                                                        aria-label={
                                                            value &&
                                                            value === 'Size'
                                                                ? 'Please select a size'
                                                                : null
                                                        }
                                                    >
                                                        Add To Cart
                                                    </button>
                                                ) : (
                                                    <button
                                                        type="submit"
                                                        className={`large-button button-atc button-no-sizes`}
                                                        data-variant-id={
                                                            currentVariantId
                                                        }
                                                    >
                                                        Add To Cart
                                                    </button>
                                                )}
                                            </form>
                                        </div>
                                    </div>
                                    <div className="registry-actions">
                                        <span
                                            className={`registry-trigger ${
                                                sizes &&
                                                sizes.length > 2 &&
                                                value &&
                                                value === 'Size'
                                                    ? 'disabled'
                                                    : null
                                            }`}
                                            data-variant-id={currentVariantId}
                                            data-balloon-blunt
                                            data-balloon-pos="up"
                                            aria-label={
                                                sizes &&
                                                sizes.length > 2 &&
                                                value &&
                                                value === 'Size'
                                                    ? 'Please select available size'
                                                    : null
                                            }
                                            onClick={() => {
                                                if (
                                                    sizes &&
                                                    sizes.length > 2 &&
                                                    value &&
                                                    value === 'Size'
                                                ) {
                                                    nullFunction()
                                                } else {
                                                    addProductToRegistry(
                                                        `${currentOriginUrl}/products/${
                                                            product.handle
                                                        }${
                                                            currentVariantId
                                                                ? '?variant=' +
                                                                  currentVariantId
                                                                : null
                                                        }`,
                                                        product.title,
                                                        currentImage
                                                            ? currentImage.src
                                                            : null,
                                                        currentVariantId,
                                                        1
                                                    )
                                                }
                                            }}
                                        >
                                            Add To Registry
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            ) : (
                <div className="loading">Loading</div>
            )}
        </Fragment>
    )
}

export default Product
